import React from "react";
import { Button, Flex, Tag, Text } from "@jsq/ds/core";
import { formatDateTimeUtc } from "#utils/date_formatter";
import { formatCountText } from "#utils/text_utils";
import {
  mutedMd,
  mutedSm,
  positionLine,
  root,
  smallTag,
  tagWrap,
  titleRow,
  titleText,
} from "./styles_vanilla.css";
import type { ActivityEvent } from "../types";

export const ActivityEventItem = ({
  event,
  onPositionClick,
  showPositionLine = true,
}: {
  event: ActivityEvent;
  onPositionClick: () => void;
  showPositionLine?: boolean;
}) => {
  const additionalEntityCount = event.entityNames.length - 1;
  const entitySuffix = additionalEntityCount > 0 ? ` +${additionalEntityCount} entities` : "";

  return (
    <Flex flexDirection="column" className={root}>
      <Flex alignItems="center" justifyContent="space-between" className={titleRow}>
        <Text variant="strong-md" className={titleText}>
          {event.title}
        </Text>
        <div className={tagWrap}>
          <Tag variant="neutral" label={event.caseTypeLabel} className={smallTag} />
        </div>
      </Flex>
      {event.subStatusInfo ? (
        <Text variant="regular-md" className={mutedMd}>
          {event.subStatusInfo}
        </Text>
      ) : null}
      {showPositionLine && (
        <Flex alignItems="baseline" className={positionLine} flexWrap="wrap">
          <Button displayAsLink isInline onClick={onPositionClick}>
            {formatCountText(event.positionCount, "position")}
          </Button>
          <Text variant="regular-md" className={mutedMd} asSpan>
            {` for ${event.entityNames[0] ?? ""}${entitySuffix}`}
          </Text>
        </Flex>
      )}
      <Text variant="regular-sm" className={mutedSm}>
        {formatDateTimeUtc(event.timestamp)}
      </Text>
    </Flex>
  );
};
